//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.0.0 (NJsonSchema v10.7.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface ApiError {
  error?: ErrorDetail | undefined;
}

export interface DeveloperException {
  readonly message?: string | undefined;
  source?: string | undefined;
  readonly stackTrace?: string | undefined;
  readonly innerException?: DeveloperException | undefined;
}

/** 0 = Unknown 1 = BadInput 2 = ConcurrencyError 3 = NoRecordFound 4 = PaymentRequired 5 = Forbidden 6 = TooManyRequests 7 = RetryAfter 8 = ClientDisconnect */
export enum ErrorCode {
  Unknown = 0,
  BadInput = 1,
  ConcurrencyError = 2,
  NoRecordFound = 3,
  PaymentRequired = 4,
  Forbidden = 5,
  TooManyRequests = 6,
  RetryAfter = 7,
  ClientDisconnect = 8
}

export interface ErrorDetail {
  /** 

0 = Unknown

1 = BadInput

2 = ConcurrencyError

3 = NoRecordFound

4 = PaymentRequired

5 = Forbidden

6 = TooManyRequests

7 = RetryAfter

8 = ClientDisconnect */
  code?: ErrorCode;
  message?: string | undefined;
  details?: ErrorDetail[] | undefined;
  target?: string | undefined;
  developerException?: DeveloperException | undefined;
}

/** 1 = User 2 = Organization 3 = UserAndOrganization */
export enum IsolationLevel {
  User = 1,
  Organization = 2,
  UserAndOrganization = 3
}

export interface OperationModel {
  id?: string;
  lastUpdatedDateTime?: string;
  name?: string | undefined;
  /** 

0 = Pending

1 = Success

2 = Failure */
  status?: OperationStatus;
}

/** 0 = Pending 1 = Success 2 = Failure */
export enum OperationStatus {
  Pending = 0,
  Success = 1,
  Failure = 2
}

export interface ValueItemModel {
  /** 

1 = User

2 = Organization

3 = UserAndOrganization */
  isolationLevel?: IsolationLevel;
  value?: string | undefined;
}

export interface ValueModel {
  app?: string | undefined;
  key?: string | undefined;
  values?: ValueItemModel[] | undefined;
  etag?: string | undefined;
}

export interface ValueModelPagedResponseModel {
  totalCount?: number;
  items?: ValueModel[] | undefined;
}
